import IMS from './IMS';

export default IMS;
